import { useMutation } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL } from '../../constants/endpoints';
import { IServerErrorResponse } from '../../types';
import { IFeeData } from '../../store/createBankTransferSlice';
import bugsnagHandler from '../../services/bugsnag.service';
import { IAchOutResponse } from './useSendAchOutMutation';

interface IPayload {
  customerId: string;
  accountExternalId: string;
  linkedAccountId: string;
  amount: string;
  feeData: IFeeData | null;
}

export const useNewSendMoneyMutation = ({
  customerId,
  accountExternalId,
  linkedAccountId,
  amount,
  feeData,
}: IPayload, onSuccess: (data: IAchOutResponse)=> void, onError: (error: IServerErrorResponse)=> void) => useMutation(
  'sendMoney',
  async () => {
    const { data } = await httpService.post(`${BASE_URL}/api/v3/user/${customerId}/${accountExternalId}/payTo/${linkedAccountId}`, {
      amount: Number(amount),
      feeData,
    });
    return data;
  },
  {
    onSuccess: (data: IAchOutResponse) => {
      onSuccess(data);
    },
    onError: (error: IServerErrorResponse) => {
      bugsnagHandler.notify(`Failed to send money, customerId: ${customerId}, linkedAccountId: ${linkedAccountId} with the error: ${error?.response?.data?.errors[0] || ''}`);
      onError(error);
    },
  },
);
